<script>
  import locations from "./locations";

  let map;
  let origin = {
    lat: "43.6461502",
    lng: "-79.39567349999999",
  };

  let limits = [
    { lng: -80.1, lat: 43.1 },
    { lng: -78.77, lat: 43.99 },
  ];

  let container;
  export let interactive = true;

  export let fg;
  export let bg;

  let mapInitialized;

  const toggleInteraction = () => {
    interactive = !interactive;
    if (interactive) {
      map.addControl(new mapboxgl.NavigationControl());
      map.addControl(
        new mapboxgl.GeolocateControl({
          positionOptions: {
            enableHighAccuracy: true,
          },
          trackUserLocation: true,
        }),
        "bottom-left"
      );
    }
  };

  function mapLoaded() {
    mapboxgl.accessToken =
      "pk.eyJ1IjoiY29udGFjdHBob3RvdG9yb250byIsImEiOiJjanBlZG1xZmIyd2hmM3dxc244dHA5czhqIn0.oemYxA-WkH0qNy-PebQmCg";

    map = new mapboxgl.Map({
      container,
      center: origin,
      maxBounds: limits,
      // style: "mapbox://styles/contactphototoronto/ckrcmj8bv11r518lqco2v6svo",
      style: "mapbox://styles/contactphototoronto/ckrcri4ki0u5217tqvyut3u4q",
      zoom: 12,
    });

    map.addControl(new mapboxgl.NavigationControl(),"bottom-right");
      map.addControl(
        new mapboxgl.GeolocateControl({
          positionOptions: {
            enableHighAccuracy: true,
          },
          trackUserLocation: true,
        }),"bottom-right"
      );

    map.on("load", function () {
      mapInitialized = true;
      // console.log(map.getStyle().layers,bg,fg)
      map.setPaintProperty("background-sepia", "background-color", fg);
      // map.setLayoutProperty("land", "visibility", "visible");
      // map.setPaintProperty("landcover", "fill-color", fg);
      // map.setPaintProperty("water", "fill-color", bg);
      // map.setLayoutProperty("water", "visibility", "visible");
      // map.setLayoutProperty("national-park", "visibility", "none");
      // map.setLayoutProperty("landcover", "visibility", "none");
      // map.setLayoutProperty("landuse", "visibility", "none");
      // map.setLayoutProperty("land-structure-polygon", "visibility", "none");
      // map.setLayoutProperty("land-structure-line", "visibility", "none");
      // map.setLayoutProperty("road-simple", "line-color", bg);
      // map.setLayoutProperty("road-label-simple", "text-color", bg);
    });

    locations.features.forEach(function (marker) {
      let img =
        marker.properties.img || "lassen-why-is-canada-warming-faster.jpg";
      var el = document.createElement("div");
      el.className = "marker-wrapper";
      el.innerHTML =
        "<div class='marker' style='background-image:url(https://scotiabankcontactphoto.com/lassen/img/" +
        img +
        ")'></div><div class='label'>" +
        marker.properties.name +
        "</div>";

      for (let child of el.children) {
        child.onclick = function () {
          let els = document.querySelectorAll(".marker-wrapper.selected") || [];
          els.forEach((e) => e.classList.remove("selected"));
          el.classList.add("selected");
        };
      }

      new mapboxgl.Marker(el).setLngLat(marker.geometry.coordinates).addTo(map);
    });
  }
</script>

<svelte:head>
  <script
    src="https://api.mapbox.com/mapbox-gl-js/v2.3.1/mapbox-gl.js"
    on:load={mapLoaded}></script>
  <link
    href="https://api.mapbox.com/mapbox-gl-js/v2.3.1/mapbox-gl.css"
    rel="stylesheet"
  />
</svelte:head>
<div class="map-container">
  <div id="map" bind:this={container} class:interactive />

  {#if !interactive}
    <button on:click={toggleInteraction} class="activate">Activate Map</button>
  {/if}
</div>

<style>
  .map-container {
    position: relative;
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background:var(--bg);
  }

  #map {
    width: 100%;
    height: 100%;
    pointer-events: none;
    position: absolute;
    place-items: center;
    mix-blend-mode:screen;    
    z-index:90;
  }

  #map.interactive {
    pointer-events: all;
  }

  :global(#map.interactive .marker-wrapper .label) {
    display: block;
  }

  :global(.marker-wrapper.selected) {
    z-index: 25;
  }

  .activate {
    display: block;
    z-index: 100;
    border-radius: 1.5rem;
    padding: 0.25em 1em;
    background: white;
    color: black;
    align-self: center;
    justify-self: center;
  }

  :global(.marker-wrapper) {
    display: flex;
    flex-direction: column;
    align-items: center;
    jsutify-content: center;
    z-index: 1;
    pointer-events: none;
    position:relative;
  }

  :global(.marker-wrapper .marker) {
    width: 4rem;
    height: 3rem;
    /* border-radius: 2.5rem; */
    background-color: black;
    background-size: contain;
    pointer-events: all;
    border:2px solid white;
  }

  :global(.marker-wrapper .label) {
    pointer-events: all;
    color: black;
    background:rgba(255,255,255,.8); 
    /* margin-top: 0.25em; */
    white-space: nowrap;
    font-weight: 700;
    font-size:.6rem;
    display: none;
    padding: 0.15em 0.5em;
    /* text-shadow: 5px 5px 10px #000000; */
    /* width: 4.5rem; */
    border-radius: .25em;
    /* width:4rem; */
    hyphens: auto;
    /* text-decoration:underline; */
    /* text-underline-offset:.2em;
    text-decoration-thickness: 2px; */
    
  }
</style>
<!-- rgba(238,238,238,.8); -->